export default __webpack_public_path__ + "static/media/plants.4cf42d6f.png";